var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('kanbanWrap',[_c('kanbanselectGroup',{on:{"now":_vm.renow}}),_vm._v(" "),(_vm.now == 1)?_c('abc'):_vm._e(),_vm._v(" "),(_vm.now == 2)?_c('feiyong'):_vm._e(),_vm._v(" "),(_vm.now == 3)?_c('diaodu',[_vm._v(">")]):_vm._e(),_vm._v(" "),(_vm.now == 4)?_c('tangci'):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6cda8fcc","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/kanban/index.vue
// module id = null
// module chunks = 